import UncknowIcon from './component'

export default UncknowIcon
